module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-afl50.c3a63f13.png";